import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo, Spinner } from "@/components/common";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            login(data.token, data.user);
            toast.success("Welcome back!");
            const dest = data.user.role === "admin" ? "/admin" : !data.user.onboarding_complete ? "/onboarding" : "/app";
            nav(loc.state?.from?.pathname || dest, { replace: true });
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen flex-col bg-background">
            <div className="p-5"><Logo /></div>
            <div className="flex flex-1 items-center justify-center px-5 pb-16">
                <div className="w-full max-w-md rounded-3xl bg-card p-8 shadow-sm">
                    <h1 className="font-display text-3xl font-700 tracking-tight text-primary">Welcome back</h1>
                    <p className="mt-2 text-sm text-muted-foreground">Sign in to find your next outing.</p>
                    <form onSubmit={submit} className="mt-6 space-y-4">
                        <div>
                            <Label htmlFor="email">Email</Label>
                            <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" />
                        </div>
                        <div>
                            <Label htmlFor="password">Password</Label>
                            <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" />
                        </div>
                        <div className="text-right">
                            <Link to="/forgot-password" className="text-sm text-accent hover:underline">Forgot password?</Link>
                        </div>
                        <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-full bg-primary hover:bg-primary/90">
                            {loading ? <Spinner className="h-5 w-5 border-white/40 border-t-white" /> : "Sign in"}
                        </Button>
                    </form>
                    <p className="mt-6 text-center text-sm text-muted-foreground">
                        New here? <Link to="/register" className="font-600 text-accent hover:underline">Join the Club</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}
